import React, {Component} from 'react';
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {
    getPlans,
    registerCustomer,
    androidCustomer
} from '../modules/planReducer'
import queryString from 'query-string'
import phoneFormatter from 'phone-formatter';

import {Grid, Step, Icon, Container, Form, Button, Message, Divider, Dimmer, Loader} from 'semantic-ui-react'

import AccountInformation from './register/AccountInformation'
import AccountAddress from './register/AccountAddress'
import AccountDetails from './register/AccountDetails'
import InvoiceDetails from './register/InvoiceDetails'
import DeviceInformation from './register/DeviceInformation'
import PaymentDetails from './register/PaymentDetails'
import BillingAddress from './register/BillingAddress'

import {history} from '../store'
import moment from 'moment';
import ReactPixel from 'react-facebook-pixel';
import Script from 'react-load-script'

let timeout = null

ReactPixel.init(process.env.REACT_APP_PIXEL_ID);
const options = {
    autoConfig: true, 	// set pixel's autoConfig
    debug: false, 		// enable logs
};

class Register extends Component {

    constructor(props) {
        super(props)
        let today = new Date()

        this.state = {
            isLoading: false,
            index: 1,
            date_of_birth: moment(),
            billing: {
                payment_type: 'credit_card',
                selectedMonth: today.getMonth(),
                selectedYear: today.getFullYear(),
                cardNumber: "",
                expMonth: "",
                expYear: "",
                cardCode: "",
            },
            error_messages: {
                message: []
            },
            happy_messages: {
                message: []
            },
            information_messages: {
                message: []
            },
            isSameAddress: true
        }
    }

    componentWillMount() {
        this.props.getPlans()
        const values = queryString.parse(this.props.location.search)
        let type = values.type
        if (type === undefined) {
            history.push('/plan')

        } else {

            let state = this.state
            state.plan_id = type
            this.setState(state)
        }
        let advancedMatching = {}
        ReactPixel.init(process.env.REACT_APP_PIXEL_ID, advancedMatching, options);
        ReactPixel.pageView();
    }

    incrementPanel(index) {
        this.setState({index})
    }

    getPlan(type) {
        let plan = this.props.plans.find(plan => {
            return plan.type === type
        })
        return plan
    }

    async nextForm() {
        let state = this.state

        let index = state.index + 1

        let advancedMatching = {em: state.email, fn: state.first_name, ln: state.last_name}
        ReactPixel.init(process.env.REACT_APP_PIXEL_ID, advancedMatching, options);
        if (index === 2) {
            ReactPixel.trackCustom('CompleteRegistration', {})
        } else if (index === 3) {
            if (state.phone_type === 'android') {
                if (state.plan_id === 'silver') {
                    ReactPixel.trackCustom('AndroidSilver', {})
                } else if (state.plan_id === 'gold') {
                    ReactPixel.trackCustom('AndroidGold', {})
                } else if (state.plan_id === 'goldlite') {
                    ReactPixel.trackCustom('AndroidGold', {})
                }
                let data = {
                    email: state.email,
                    first_name: state.first_name,
                    last_name: state.last_name,
                    address1: state.address1,
                    address2: state.address2,
                    city: state.city,
                    state: state.state,
                    zip: state.zip,
                    country: state.country,
                }
                this.setState({isLoading: true})

                let response = await this.props.androidCustomer(data)
                if (response.data.valid) {
                    response.data.messages.forEach(message => {
                        state.happy_messages.message.push(message)
                    })
                    state.error_messages.message = []
                    state.isLoading = false

                    history.push({
                        pathname: '/thanks',
                        state: {message: state.happy_messages.message}
                    })
                }
            }
            ReactPixel.trackCustom('InitiateCheckout', {})
        }
        this.setState({index})

    }

    copyAddresss = (state) => {
        state.billing.first_name = state.first_name;
        state.billing.last_name = state.last_name;
        state.billing.address = state.address1;
        state.billing.address2 = state.address2;
        state.billing.city = state.city;
        state.billing.state = state.state;
        state.billing.zip = state.zip;
        state.billing.country = state.country;
    }

    checkValidPaymentDetails(state) {
        if (timeout) clearTimeout(timeout)
        timeout = setTimeout(() => {
            if (state.billing.cardNumber && state.billing.selectedMonth && state.billing.selectedYear && state.billing.cardCode) {
                let advancedMatching = {em: state.email, fn: state.first_name, ln: state.last_name}
                ReactPixel.init(process.env.REACT_APP_PIXEL_ID, advancedMatching, options);
                ReactPixel.trackCustom('AddPaymentInfo', {})
            }
        }, 1000)
    }

    handleChange = (key, value) => {
        let state = this.state
        let keys = key.split('.')
        if (keys[1]) {
            state[keys[0]][keys[1]] = value
        } else {
            state[key] = value

            if (state.isSameAddress) {
                this.copyAddresss(state)
            }
        }
        if (state.email && state.first_name && state.last_name) {
            let advancedMatching = {em: state.email, fn: state.first_name, ln: state.last_name}
            ReactPixel.init(process.env.REACT_APP_PIXEL_ID, advancedMatching, options);
            ReactPixel.pageView();
        }
        this.checkValidPaymentDetails(state)
        this.setState(state)
    }

    deleteTempVariables(data) {
        delete data.billing.selectedMonth
        delete data.billing.selectedYear
        delete data.billing.cardNumber
        delete data.billing.expMonth
        delete data.billing.expYear
        delete data.billing.cardCode
        delete data.index
        delete data.error_messages
        delete data.happy_messages
        delete data.information_messages
        delete data.isSameAddress
        delete data.isLoading
    }

    handleSubmit = async () => {
        let state = this.state
        let data = JSON.parse(JSON.stringify(state))
        if (state.home_phone) data.home_phone = phoneFormatter.format(state.home_phone, "NNN-NNN-NNNN")
        if (state.emergency_phone) data.emergency_phone = phoneFormatter.format(state.emergency_phone, "NNN-NNN-NNNN")
        if (state.police_phone) data.police_phone = phoneFormatter.format(state.police_phone, "NNN-NNN-NNNN")
        if (state.date_of_birth) data.date_of_birth = state.date_of_birth.format('DD/MM/YYYY')

        this.deleteTempVariables(data)
        this.setState({isLoading: true})
        let response = await this.props.registerCustomer(data)

        if (response.data.errors.length > 0) {
            state.happy_messages.message = []
            response.data.errors.forEach(error => {
                state.error_messages.message.push(error)
            })
            state.isLoading = false
            if (response.data.offerSilverPlan) {
                state.plan_id = 'silver'
            }
            if (response.data.token) {
                state.token = response.data.token
            }
            this.setState(state)
        } else {
            response.data.messages.forEach(message => {
                state.happy_messages.message.push(message)

            })
            state.error_messages.message = []
            state.index++
            state.isLoading = false

            this.setState(state)

            let plan = this.getPlan(state.plan_id)
            let advancedMatching = {em: state.email, fn: state.first_name, ln: state.last_name}
            ReactPixel.init(process.env.REACT_APP_PIXEL_ID, advancedMatching, options);
            ReactPixel.trackCustom('Purchase', {
                value: plan.price,
                currency: 'USD'
            })

            history.push({
                pathname: '/thanks',
                state: {message: state.happy_messages.message}
            })
        }
    }


    responseHandler(response) {

        if (response.messages.resultCode === "Error") {
            this.handleChange('error_messages', response.messages)
            this.handleSubmit()
        } else {
            this.handleChange('billing.payment_nonce', response.opaqueData.dataValue)
            this.handleSubmit()
        }
    }

    sendPaymentDataToAnet() {

        let state = this.state
        state.error_messages.message = []
        this.setState(state)
        var authData = {};
        authData.clientKey = process.env.REACT_APP_CLIENT_KEY;
        authData.apiLoginID = process.env.REACT_APP_API_LOGIN_ID;
        var cardData = {};
        cardData.cardNumber = this.state.billing.cardNumber
        cardData.month = this.state.billing.selectedMonth + ""
        cardData.year = this.state.billing.selectedYear + ""
        cardData.cardCode = this.state.billing.cardCode

        var secureData = {};
        secureData.authData = authData;
        secureData.cardData = cardData;

        window.Accept.dispatchData(secureData, this.responseHandler.bind(this));
    }

    render = () => {
        let plan = this.getPlan(this.state.plan_id)
        let messageList = (messages) => {
            return messages.map(message => message.text || message)
        }

        let errorMessages = this.state.error_messages.message.length > 0 ? <Message
            error
            header='There was some errors with your submission'
            list={messageList(this.state.error_messages.message)}
        /> : null

        let happyMessages = this.state.happy_messages.message.length > 0 ? <Message
            success
            header='Your user registration was successful'
            list={messageList(this.state.happy_messages.message)}
        /> : null
        let informationMessages = this.state.information_messages.message.length > 0 ? <Message
            info
            header='Information'
            list={messageList(this.state.information_messages.message)}
        /> : null

        return (
            <div>
                <Script url={process.env.REACT_APP_CLIENT_URL} />
                <Container textAlign='justified'>
                    <br/>
                    <Grid centered><h1 style={{color: "white"}}>Register</h1></Grid>
                    <br/>
                    <Divider horizontal>Secure Checkout</Divider>
                    {errorMessages}
                    {happyMessages}
                    {informationMessages}

                    <Step.Group widths={3} size='tiny' attached='top'>
                        <Step active={this.state.index === 1} completed={this.state.index > 1}
                              onClick={() => this.incrementPanel(1)}>
                            <Icon name='truck'/>
                            <Step.Content>
                                <Step.Title>Account Information</Step.Title>
                                <Step.Description>Enter you Account Information</Step.Description>
                            </Step.Content>
                        </Step>
                        <Step active={this.state.index === 2} completed={this.state.index > 2}
                              onClick={() => this.incrementPanel(2)}>
                            <Icon name='info'/>
                            <Step.Content>
                                <Step.Title>Invoice Details</Step.Title>
                                <Step.Description>Enter you Billing Information</Step.Description>
                            </Step.Content>
                        </Step>
                        <Step active={this.state.index === 3} completed={this.state.index > 3}
                              onClick={() => this.incrementPanel(3)}>
                            <Icon name='credit card'/>
                            <Step.Content>
                                <Step.Title>Payment</Step.Title>
                            </Step.Content>
                        </Step>
                    </Step.Group>

                    <Form className='attached  segment'>
                        <Dimmer active={this.state.isLoading}>
                            <Loader indeterminate>Processing...</Loader>
                        </Dimmer>
                        {this.state.index === 1 ?
                            <div>
                                <Form.Group widths='equal'>
                                    <Form.Field control={Button} floated='right'
                                                onClick={this.nextForm.bind(this)}>Continue</Form.Field>
                                </Form.Group>
                                <Grid>
                                    <Grid.Row style={{marginRight: 0, marginLeft: 0}}>
                                        <Grid.Column mobile={16} tablet={16} computer={8}>
                                            <br/>
                                            <AccountInformation change={this.handleChange.bind(this)}
                                                                data={this.state}/>
                                        </Grid.Column>
                                        <Grid.Column mobile={16} tablet={16} computer={8}>
                                            <br/>
                                            <AccountAddress change={this.handleChange.bind(this)}
                                                            data={this.state}/>
                                        </Grid.Column>
                                        <Grid.Column width={16}>
                                            <br/>
                                            {this.state.plan_id === 'gold' || this.state.plan_id === 'goldlite' ?
                                                <AccountDetails change={this.handleChange.bind(this)}
                                                                data={this.state}/> : null}
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                                <Form.Group widths='equal'>
                                    <Form.Field control={Button} floated='right'
                                                onClick={this.nextForm.bind(this)}>Continue</Form.Field>
                                </Form.Group>
                            </div>
                            : null}
                        {this.state.index === 2 ?
                            <div>
                                <Form.Group widths='equal'>
                                    <Form.Field control={Button} floated='right'
                                                onClick={this.nextForm.bind(this)}>Continue</Form.Field>
                                </Form.Group>
                                <Grid>
                                    <Grid.Row style={{marginRight: 0, marginLeft: 0}}>
                                        <Grid.Column mobile={16} tablet={16} computer={8}>
                                            <br/>
                                            <InvoiceDetails plan={plan} change={this.handleChange.bind(this)}
                                                            data={this.state}/>
                                        </Grid.Column>
                                        <Grid.Column mobile={16} tablet={16} computer={8}>
                                            <br/>

                                            <DeviceInformation change={this.handleChange.bind(this)}
                                                               data={this.state}/>
                                        </Grid.Column>
                                        <Grid.Column width={16}>
                                            <br/>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                                <Form.Group widths='equal'>
                                    <Form.Field control={Button} floated='right'
                                                onClick={this.nextForm.bind(this)}>Continue</Form.Field>
                                </Form.Group>
                            </div>
                            : null}
                        {this.state.index === 3 ?
                            <div>
                                <Form.Group widths='equal'>
                                    <Form.Field control={Button} floated='right'
                                                onClick={this.sendPaymentDataToAnet.bind(this)}>Submit</Form.Field>
                                </Form.Group>
                                <Grid>
                                    <Grid.Row centered style={{marginRight: 0, marginLeft: 0}}>
                                        <Grid.Column mobile={16} tablet={16} computer={8}>
                                            <br/>
                                            <BillingAddress change={this.handleChange.bind(this)}
                                                            data={this.state}/>
                                        </Grid.Column>
                                        <Grid.Column mobile={16} tablet={16} computer={8} >
                                            <br/>
                                            <PaymentDetails change={this.handleChange.bind(this)}
                                                            submit={this.handleSubmit.bind(this)}
                                                            data={this.state}/>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                                <Form.Group widths='equal'>
                                    <Form.Field control={Button} floated='right'
                                                onClick={this.sendPaymentDataToAnet.bind(this)}>Submit</Form.Field>
                                </Form.Group>
                            </div>
                            : null}
                    </Form>

                </Container>
                <br/>
                <br/>
            </div>
        );
    }
}


const mapStateToProps = state => ({plans: state.planReducer.plans})
const mapDispatchToProps = dispatch => bindActionCreators({
    getPlans,
    registerCustomer,
    androidCustomer
}, dispatch)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Register)


// WEBPACK FOOTER //
// ./src/containers/Register.js